// Bookmarklet "Ambil Sampel Uji AI" — kode lokal yang dapat diaudit (tanpa skrip eksternal).
// Dijalankan Owner di tab LIVE yang sudah login. Memakai sesi browser resmi (cookie httpOnly; kode ini
// tidak membaca/menyalin/menyimpan token atau cookie). Hanya GET ke daftar izin. Maks 10 file.
// Catatan: kode di dalam SAMPLER_SOURCE sengaja tanpa backtick/template agar aman sebagai string.
export const SAMPLER_SOURCE = String.raw`(function(){
"use strict";
var TOOL = "tamfaris-sampler-v1";
var OFFICIAL_HOST = "app.tamfaris.com", KDF_ITER = 20000;
var MAX_FILES = 10, MAX_FILE_BYTES = 10 * 1024 * 1024;
var QUOTA = {multi_produk: 1, produk_khusus: 1, warna_kontras: 2, lengan_panjang: 3, lengan_pendek: 3};
var ORDER = ["multi_produk", "produk_khusus", "warna_kontras", "lengan_panjang", "lengan_pendek"];
var ALLOW = [/^\/api\/auth\/me$/, /^\/api\/orders$/, /^\/api\/shopee\?limit=500&include_batal=false$/,
  /^\/api\/files\/[A-Za-z0-9-]{8,64}\/download$/, /^\/api\/shopee\/files\/[A-Za-z0-9-]{8,64}\/download$/];
var COLORS = {hitam:["hitam","black"], putih:["putih","white","broken white","off white"], abu:["abu","abu abu","grey","gray","misty"],
  navy:["navy","dongker","biru dongker","biru tua"], biru:["biru","blue","benhur","biru muda"], tosca:["tosca","toska"],
  hijau:["hijau","green","army","botol","olive","stabilo"], merah:["merah","red","cabe"], maroon:["maroon","marun","burgundy"],
  kuning:["kuning","yellow","mustard"], oranye:["oranye","orange"], pink:["pink","merah muda","fanta"], ungu:["ungu","purple","lilac"],
  coklat:["coklat","cokelat","brown","moka"], krem:["krem","cream","beige","khaki"]};
var PRODUCTS = {polo:["polo","kerah"], hoodie:["hoodie","hodie","jumper"], jaket:["jaket","jacket","parka","bomber","varsity"],
  jersey:["jersey","jersy"], sweater:["sweater","crewneck"], rompi:["rompi","vest"],
  kaos:["kaos","t shirt","tshirt","oblong","raglan"]};
var SPECIAL = {polo:1, hoodie:1, jersey:1, jaket:1, pdh:1, workshirt:1, kemeja_lainnya:1, sweater:1, rompi:1};
// Kemeja dari NAMA PRODUK RESMI: PDH (skoder) > Workshirt (tanpa skoder) > kemeja lainnya.
var SHIRT_PRIORITY = [["pdh", ["pdh"]], ["workshirt", ["workshirt", "work shirt"]]], SHIRT_GENERIC = ["kemeja", "pdl", "shirt kerja"];
var DARK = {hitam:1, navy:1, maroon:1, coklat:1}, LIGHT = {putih:1, kuning:1, krem:1, pink:1};

function allowed(p) { for (var i = 0; i < ALLOW.length; i++) { if (ALLOW[i].test(p)) return true; } return false; }
function safeGet(p) {
  if (!allowed(p)) return Promise.reject(new Error("Endpoint tidak diizinkan: " + p));
  return fetch(p, {method: "GET", credentials: "same-origin", cache: "no-store", redirect: "error"}).then(function (r) {
    if (!r.ok) throw new Error("HTTP " + r.status + " " + p);
    return r;
  });
}
function norm(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " "); }
function alnum(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
function alias(text, table) {
  var t = " " + norm(text) + " ", best = "", bl = 0;
  Object.keys(table).forEach(function (k) { table[k].forEach(function (w) {
    if (t.indexOf(" " + norm(w) + " ") >= 0 && w.length > bl) { best = k; bl = w.length; } }); });
  return best;
}
function sleeve(text) {
  var t = " " + norm(text) + " ";
  if (/ (tanpa lengan|sleeveless|singlet|kutung) /.test(t)) return "tanpa_lengan";
  if (/ (panjang|long|lp) /.test(t)) return "panjang";
  if (/ (pendek|short|pdk) /.test(t)) return "pendek";
  return "";
}
function productOf(text) {
  var t = " " + norm(text) + " ", has = function (w) { return t.indexOf(" " + norm(w) + " ") >= 0; };
  for (var i = 0; i < SHIRT_PRIORITY.length; i++) { if (SHIRT_PRIORITY[i][1].some(has)) return SHIRT_PRIORITY[i][0]; }
  if (SHIRT_GENERIC.some(has)) return "kemeja_lainnya";
  return alias(text, PRODUCTS);
}
function attrs(text) { return {product: productOf(text), sleeve: sleeve(text), color: alias(text, COLORS), order_text: String(text || "").slice(0, 200)}; }
function tags(items) {
  var t = {}, keys = {};
  items.forEach(function (i) { keys[i.product + "|" + i.sleeve + "|" + i.color] = 1; if (SPECIAL[i.product]) t.produk_khusus = 1; });
  if (Object.keys(keys).length >= 2) t.multi_produk = 1;
  if (items.length === 1) {
    var i = items[0];
    if (i.color === "putih" || i.color === "hitam") t.warna_kontras = 1;
    if (i.sleeve === "panjang") t.lengan_panjang = 1;
    if (i.sleeve === "pendek") t.lengan_pendek = 1;
  }
  return t;
}
function tone(c) { var col = c.items.length === 1 ? c.items[0].color : ""; return DARK[col] ? "gelap" : (LIGHT[col] ? "terang" : ""); }
function hex(buf) { return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ("0" + b.toString(16)).slice(-2); }).join(""); }
function newSalt() { return hex(crypto.getRandomValues(new Uint8Array(16)).buffer); }
// Sidik ber-salt acak per ZIP (PBKDF2-SHA256). No. HP & nomor pesanan TIDAK disimpan sama sekali.
function kdf(s, salt) {
  var enc = new TextEncoder();
  return crypto.subtle.importKey("raw", enc.encode(s), "PBKDF2", false, ["deriveBits"]).then(function (k) {
    return crypto.subtle.deriveBits({name: "PBKDF2", hash: "SHA-256", salt: enc.encode(salt), iterations: KDF_ITER}, k, 256);
  }).then(hex);
}
function hashIds(p, salt) {
  var name = norm(p.customer_name), acct = alnum(p.customer_account);
  var words = name ? name.split(" ").filter(function (w) { return w.length >= 4; }) : [];
  var h = function (v) { return kdf(v, salt); };
  return Promise.all([name.length >= 4 ? h(name) : "", acct.length >= 4 ? h(acct) : "", Promise.all(words.map(h))]).then(function (r) {
    var wh = r[2].filter(function (v, i, a) { return a.indexOf(v) === i; }).sort();
    return {name_hash: r[0], name_words: name ? name.split(" ").length : 0, word_hashes: wh, account_hash: r[1]};
  });
}
function officialOrigin(loc) { return !!loc && loc.protocol === "https:" && loc.hostname === OFFICIAL_HOST; }
function offlineCandidates(orders) {
  var out = [];
  (orders || []).forEach(function (o) {
    if (o.order_status === "Draft" || o.order_status === "Dibatalkan" || String(o.source || "").toLowerCase() === "shopee") return;
    if (o.hold && o.hold.active) return;
    var prods = (o.products || []).filter(function (p) { return p.production_route !== "Non-Produksi"; });
    var fid = "";
    prods.forEach(function (p) { var s = p.mockup_done_snapshot || {}; if (!fid && s.file_id) fid = s.file_id; });
    if (!fid) return;
    var items = prods.map(function (p) { return attrs([p.custom_name || p.name, p.material, p.color, p.sleeve].join(" ")); });
    out.push({channel: "offline", order_number: o.order_number, file_id: fid, path: "/api/files/" + fid + "/download", items: items,
      ids: {customer_name: o.customer_name, customer_account: ""}});
  });
  return out;
}
function shopeeCandidates(jobs) {
  var out = [];
  (jobs || []).forEach(function (j) {
    if (j.status === "BATAL" || j.warehouse_state !== "sent" || (j.hold && j.hold.active)) return;
    var snap = (j.warehouse_sent_snapshot || [])[0];
    if (!snap || !snap.file_id) return;
    var lines = String(j.description || "").split("\n").map(function (l) { var m = /^\s*•\s*(.+?)(?:\s+×\s*\d+)?\s*$/.exec(l); return m ? m[1] : ""; })
      .filter(Boolean);
    if (!lines.length) lines = [j.design_title || ""];
    out.push({channel: (j.channel || j.marketplace) === "tokopedia" ? "tokopedia" : "shopee", order_number: j.order_number, file_id: snap.file_id,
      path: "/api/shopee/files/" + snap.file_id + "/download", items: lines.map(attrs),
      ids: {customer_name: j.customer_name, customer_account: j.customer_account}});
  });
  return out;
}
function rng(seed) { var s = seed >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
function select(cands, seed) {
  var r = rng(seed || 7), pool = cands.slice(), used = {}, chosen = [];
  for (var i = pool.length - 1; i > 0; i--) { var k = Math.floor(r() * (i + 1)); var t = pool[i]; pool[i] = pool[k]; pool[k] = t; }
  pool.forEach(function (c) { c.tags = tags(c.items); c.tone = tone(c); });
  ORDER.forEach(function (cat) {
    var need = QUOTA[cat], prefs = (cat === "multi_produk" || cat === "produk_khusus") ? [""] : ["gelap", "terang", ""];
    var round = 0;
    while (need > 0 && round < 6) {
      var want = prefs[round % prefs.length], got = null;
      for (var j = 0; j < pool.length; j++) {
        var c = pool[j];
        if (used[c.file_id] || !c.tags[cat] || (want && c.tone !== want)) continue;
        got = c; break;
      }
      if (got) { used[got.file_id] = 1; chosen.push(Object.assign({}, got, {category: cat})); need--; }
      round++;
    }
  });
  return chosen.slice(0, MAX_FILES).map(function (c, n) { return Object.assign(c, {sample_id: "S" + ("0" + (n + 1)).slice(-2)}); });
}
function kindOf(b) {
  if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47 && b[4] === 0x0d && b[5] === 0x0a && b[6] === 0x1a && b[7] === 0x0a) return "png";
  if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return "jpg";
  if (b[0] === 0x52 && b[1] === 0x49 && b[2] === 0x46 && b[3] === 0x46 && b[8] === 0x57 && b[9] === 0x45 && b[10] === 0x42 && b[11] === 0x50) return "webp";
  if (b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46) return "pdf";
  return "";
}
var CRC = (function () { var t = []; for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } return t; })();
function crc32(b) { var c = 0xffffffff; for (var i = 0; i < b.length; i++) c = CRC[(c ^ b[i]) & 0xff] ^ (c >>> 8); return (c ^ 0xffffffff) >>> 0; }
function zip(files) {
  var parts = [], central = [], off = 0, enc = new TextEncoder();
  function u16(v) { return [v & 255, (v >>> 8) & 255]; }
  function u32(v) { return [v & 255, (v >>> 8) & 255, (v >>> 16) & 255, (v >>> 24) & 255]; }
  files.forEach(function (f) {
    var name = enc.encode(f.name), crc = crc32(f.data), n = f.data.length;
    var head = [].concat(u32(0x04034b50), u16(20), u16(0x0800), u16(0), u16(0), u16(0x21), u32(crc), u32(n), u32(n), u16(name.length), u16(0));
    parts.push(new Uint8Array(head), name, f.data);
    central.push(new Uint8Array([].concat(u32(0x02014b50), u16(20), u16(20), u16(0x0800), u16(0), u16(0), u16(0x21), u32(crc), u32(n), u32(n),
      u16(name.length), u16(0), u16(0), u16(0), u16(0), u32(0), u32(off))), name);
    off += head.length + name.length + n;
  });
  var csize = central.reduce(function (s, p) { return s + p.length; }, 0);
  var end = new Uint8Array([].concat(u32(0x06054b50), u16(0), u16(0), u16(files.length), u16(files.length), u32(csize), u32(off), u16(0)));
  return new Blob(parts.concat(central, [end]), {type: "application/zip"});
}
function el(tag, css, text) { var e = document.createElement(tag); if (css) e.style.cssText = css; if (text) e.textContent = text; return e; }
function panel(chosen, onOk, onShuffle) {
  var wrap = el("div", "position:fixed;inset:0;background:rgba(15,23,42,.6);z-index:2147483647;display:flex;align-items:center;justify-content:center;font-family:sans-serif");
  wrap.setAttribute("data-testid", "tf-sampler-panel");
  var box = el("div", "background:#fff;color:#0f172a;max-width:860px;width:96%;max-height:90vh;overflow:auto;border-radius:10px;padding:16px");
  box.appendChild(el("h3", "margin:0 0 6px", "Sampel Uji AI — periksa sebelum diunduh (" + chosen.length + "/" + MAX_FILES + ")"));
  box.appendChild(el("div", "font-size:12px;color:#475569;margin-bottom:8px", "Baca-saja. Nomor pesanan hanya tampil di layar ini dan TIDAK ikut tersimpan. Identitas pelanggan disimpan sebagai sidik (hash) untuk pembersihan."));
  var tb = el("table", "width:100%;border-collapse:collapse;font-size:12px");
  chosen.forEach(function (c) {
    var tr = el("tr", "border-top:1px solid #e2e8f0");
    tr.setAttribute("data-testid", "tf-sampler-row-" + c.sample_id);
    [c.sample_id, c.category + (c.tone ? " · " + c.tone : ""), c.channel, c.order_number,
     c.items.map(function (i) { return (i.product || "?") + "/" + (i.sleeve || "?") + "/" + (i.color || "?"); }).join("; ")]
      .forEach(function (v) { tr.appendChild(el("td", "padding:4px 6px", String(v || ""))); });
    tb.appendChild(tr);
  });
  box.appendChild(tb);
  var miss = ORDER.filter(function (k) { return chosen.filter(function (c) { return c.category === k; }).length < QUOTA[k]; });
  if (miss.length) box.appendChild(el("div", "color:#b45309;font-size:12px;margin-top:6px", "Kategori kurang: " + miss.join(", ")));
  var msg = el("div", "font-size:12px;margin-top:8px;color:#1d4ed8");
  msg.setAttribute("data-testid", "tf-sampler-msg");
  var bar = el("div", "display:flex;gap:8px;justify-content:flex-end;margin-top:10px");
  var bCancel = el("button", "padding:6px 12px", "Batal"), bShuffle = el("button", "padding:6px 12px", "Acak ulang"),
      bOk = el("button", "padding:6px 12px;background:#0f172a;color:#fff;border:0;border-radius:6px", "Setujui & Unduh ZIP");
  bCancel.setAttribute("data-testid", "tf-sampler-cancel"); bShuffle.setAttribute("data-testid", "tf-sampler-shuffle"); bOk.setAttribute("data-testid", "tf-sampler-ok");
  bCancel.onclick = function () { wrap.remove(); };
  bShuffle.onclick = function () { wrap.remove(); onShuffle(); };
  bOk.onclick = function () { bOk.disabled = true; bShuffle.disabled = true; onOk(msg).then(function () { setTimeout(function () { wrap.remove(); }, 1500); },
    function (e) { msg.style.color = "#b91c1c"; msg.textContent = "Gagal: " + e.message; bOk.disabled = false; }); };
  bar.appendChild(bCancel); bar.appendChild(bShuffle); bar.appendChild(bOk);
  box.appendChild(msg); box.appendChild(bar); wrap.appendChild(box); document.body.appendChild(wrap);
  return wrap;
}
function build(chosen, msg) {
  var files = [], samples = [], i = 0, salt = newSalt();
  function next() {
    if (i >= chosen.length) return null;
    var c = chosen[i++];
    msg.textContent = "Mengunduh " + c.sample_id + " (" + i + "/" + chosen.length + ")…";
    return safeGet(c.path).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
      var b = new Uint8Array(buf), ext = kindOf(b);
      if (!ext || b.length > MAX_FILE_BYTES) return next();
      return hashIds(c.ids, salt).then(function (h) {
        files.push({name: "files/" + c.sample_id + "." + ext, data: b});
        samples.push({sample_id: c.sample_id, file: "files/" + c.sample_id + "." + ext, category: c.category, channel: c.channel,
          items: c.items, identifiers: h});
        return next();
      });
    });
  }
  return Promise.resolve(next()).then(function () {
    var man = {tool: TOOL, version: 1, created_at: new Date().toISOString(), kdf: {alg: "pbkdf2-sha256", iter: KDF_ITER, salt: salt}, samples: samples};
    files.unshift({name: "manifest.json", data: new TextEncoder().encode(JSON.stringify(man, null, 2))});
    return zip(files);
  });
}
function save(blob) {
  var a = document.createElement("a"), u = URL.createObjectURL(blob);
  a.href = u; a.download = "tamfaris_sampel_ai_" + new Date().toISOString().slice(0, 10) + ".zip";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function () { URL.revokeObjectURL(u); }, 5000);
}
function main(seed, loc) {
  if (!officialOrigin(loc || window.location)) {
    alert("Ambil Sampel Uji AI hanya boleh dijalankan di domain LIVE resmi TAMFARIS (" + OFFICIAL_HOST + ", HTTPS). Dibatalkan.");
    return Promise.resolve();
  }
  return safeGet("/api/auth/me").then(function (r) { return r.json(); }).then(function (me) {
    if (String(me.role || "").toLowerCase() !== "owner") throw new Error("Hanya Owner yang dapat menjalankan pengambilan sampel.");
    return Promise.all([safeGet("/api/orders").then(function (r) { return r.json(); }),
      safeGet("/api/shopee?limit=500&include_batal=false").then(function (r) { return r.json(); })]);
  }).then(function (res) {
    var chosen = select(offlineCandidates(res[0]).concat(shopeeCandidates((res[1] || {}).items)), seed);
    panel(chosen, function (msg) { return build(chosen, msg).then(function (blob) { save(blob); msg.textContent = "ZIP terunduh. Tidak ada data yang diubah."; }); },
      function () { main((seed || 7) + 1, loc); });
  }).catch(function (e) { alert("Ambil Sampel Uji AI: " + e.message); });
}
var api = {officialOrigin: officialOrigin, newSalt: newSalt, productOf: productOf,
  allowed: allowed, safeGet: safeGet, attrs: attrs, tags: tags, select: select, hashIds: hashIds, offlineCandidates: offlineCandidates,
  shopeeCandidates: shopeeCandidates, kindOf: kindOf, crc32: crc32, zip: zip, build: build, main: main, panel: panel, QUOTA: QUOTA};
if (typeof window !== "undefined" && window.__TF_SAMPLER_TEST__) { window.__TF_SAMPLER_TEST__.api = api; return; }
main(7);
})();`;

export const samplerHref = () => "javascript:" + encodeURIComponent(SAMPLER_SOURCE);
